<template>
  <Flex
    direction="column"
    fullWidth
    v-test="'tw-page-reviews'"
  >
    <Flex
      direction="column"
      :gap="0.25"
    >
      <BaseHeading size="l">
        {{ $t('admin.treatwell.pages.reviews.heading') }}
      </BaseHeading>
      <BaseText color="secondary">
        {{ $t('admin.treatwell.pages.reviews.subheading') }}
      </BaseText>
    </Flex>
    <BaseCard :heading="$t('admin.treatwell.pages.reviews.progress_heading')">
      <ReviewsProgress />
    </BaseCard>
    <BaseCard :heading="$t('admin.treatwell.pages.reviews.card_heading')">
      <ReviewTasks
        :treatwellVenue="treatwellVenue"
        :enableSection="enableSection"
      />
    </BaseCard>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import type { TreatwellVenue } from '@/types';
import ReviewsProgress from '../tasks/ReviewsProgress.vue';
import ReviewTasks from '../tasks/ReviewTasks.vue';

// Customer feedback, and pushing it to the marketplace page as reviews
defineProps<{
  treatwellVenue: Partial<TreatwellVenue> | null;
  enableSection: boolean;
}>();
</script>
